import { render, staticRenderFns } from "./DdTimeBoxInside.vue?vue&type=template&id=081eb0e0&scoped=true&"
import script from "./DdTimeBoxInside.vue?vue&type=script&lang=js&"
export * from "./DdTimeBoxInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081eb0e0",
  null
  
)

export default component.exports